import React from 'react';
import sanitize from 'utils/sanitize';

import Button from 'components/shared/Button';
import Link from 'components/shared/Link';

export type TooltipModalContentProps = {
  id: number;
  readOnly: boolean;
  tooltipTitle: string;
  tooltipDescription: string;
  tooltipUrl: string;
  tooltipImg: string;
  parentId: number | null;
  handleTooltipSelect: (id: number, parentId: number | null) => void;
};

function TooltipModalContent({
  id,
  readOnly,
  tooltipTitle,
  tooltipDescription,
  tooltipUrl,
  tooltipImg,
  parentId = null,
  handleTooltipSelect = () => {},
}: TooltipModalContentProps) {
  return (
    <div className="panel_tooltip">
      <div className="panel_tooltip_inner">
        <div className="panel_tooltip_content">
          <h4 className="panel_tooltip_header">{sanitize(tooltipTitle)}</h4>
          <p
            className="panel_tooltip_description"
            dangerouslySetInnerHTML={{ __html: tooltipDescription }}
          />
          <p>
            {!readOnly && (
              <Button type="outline" onClick={() => handleTooltipSelect(id, parentId)}>
                Select this option
              </Button>
            )}
            {tooltipUrl && <Link href={tooltipUrl}>Learn More</Link>}
          </p>
        </div>
        {tooltipImg && (
          <div className="panel_tooltip_img">
            <img src={tooltipImg} alt={sanitize(tooltipTitle)} />
          </div>
        )}
      </div>
    </div>
  );
}

export default TooltipModalContent;
